<template>
   <div class="row bgc-wrapper margin-top-42">
    <div class="col-lg-12 col-md-12 col-sm-12 traveller-heading accordion-toggle">
      <div class="row">
        <div>
          <button
            id = "change_in_access"
            type="button"
            class="expand-form-button"
            data-toggle="collapse"
            aria-label="Expand Journey Details"
            data-target="#ChangeInExcess"
          >
            <img alt="Toggle Policy Details" src="@/assets/images/arr-up.png" />
          </button>
        </div>
        <h3>Change in Excess</h3>
      </div>
    </div>
    <div class="collapse show col-lg-12 col-md-12 col-sm-12 bgc-form-box" id="ChangeInExcess">
        <!--Excess Type* starts-->
        <div class="row">
          <div class="col-lg-3 col-md-3 col-sm-6" v-if="changeInExcessData.excessType.visibility">
            <div class="row form-group">
              <float-label label="Excess Type*" :fixed="isFloat(changeInExcessData.excessType.value)"> 
                <input
                  v-model="changeInExcessData.excessType.value"
                  v-evolvews="changeInExcessData.excessType"
                  type="text"
                  maxlength="20"
                  :class="{'bgc-error-field':changeInExcessData.excessType.errorText !== '',}"
                  class="form-control"
                  placeholder="Excess Type*"
                />
              </float-label>
               <span class="error-text" v-if="changeInExcessData.excessType.errorText !== ''">
                    {{changeInExcessData.excessType.errorText}}</span>
            </div>
          </div>
          <!--Excess Type* ends-->
          <!--Additional Excess Amount* starts-->
          <div class="col-lg-3 col-md-3 col-sm-6" v-if="changeInExcessData.additionalExcessAmount.visibility">
            <div class="row form-group">
              <float-label label="Additional Excess Amount*" :fixed="isFloat(changeInExcessData.additionalExcessAmount.value)"> 
                <input
                  v-model="changeInExcessData.additionalExcessAmount.value"
                  v-evolvews="changeInExcessData.additionalExcessAmount"
                  type="text"
                  maxlength="20"
                  v-on:keydown="onlyNumber" 
                  :class="{'bgc-error-field':changeInExcessData.additionalExcessAmount.errorText !== '',}"
                  class="form-control"
                  placeholder="Additional Excess Amount*"
                />
              </float-label>
               <span class="error-text" v-if="changeInExcessData.additionalExcessAmount.errorText !== ''">
                    {{changeInExcessData.additionalExcessAmount.errorText}}</span>
            </div>
          </div>
          <!--Additional Excess Amount* ends-->
            </div>
    </div>
    </div>
</template>
<script>
import FloatLabel from "@/../shared_component/FloatLabel.vue";
import functions from "@/../../masters/functions.js";
import base from "@/../../masters/base.js";
import Breadcrumb from "@/../../shared_component/Breadcrumb.vue";
import vSelect from "vue-select";
import { reactive, onUpdated } from "@vue/composition-api";
export default {
  name: "ChangeInExcess",
  props: ["changeInExcessData"],
  components: {
    FloatLabel
  },
  setup(props, context) {
    let state = reactive({});
    const checkError = functions.checkError;
    const isInputError = functions.isInputError;
    const isFloat = functions.isFloat;
    const onlyNumber =  functions.onlyNumber;
    onUpdated(()=>{
      let progressStep = 0;
      Object.values(props.changeInExcessData).forEach(obj => {
        if(obj.stepsMandatory){
          if(obj.value && !obj.errorText){
            progressStep++;
          }
        }
      })
      context.parent.updateSteps(progressStep);
      context.parent.enableCalculatePremiumBtn('changeInExcess');
    })
    return {
      state,
      isFloat,
      checkError,
      isInputError,
      onlyNumber
    };
  },
  directives: {
    evolvews: functions.evolvews
  }
};
</script>


